registerComponent("product-blocks/product-platforms", function (component) {

});
